<nav class="subnav">
  <ul class="nav">
    <li class="nav-item" *ngFor="let item of statusButtons let i = index" >
      <a class="nav-link" (click)="changeOverviewStatus(i)">{{ item.display }}</a>
    </li>
  </ul>
</nav>

<main>
  <app-requests-overview [status]="status"></app-requests-overview>
</main>
